<template>
    <div class="examSignIn">
        <div class="examSignIn-box">
            <div class="printCont">
                <div id="printCont" ref="print-content">
                    <div class="logo">
                        <img class="img" :src="require('@/assets/images/cqjtdxLogo.png')" alt="">
                    </div>
                    <div class="student-info">
                        <div class="info-l">
                            <!-- <el-image
                                class="img"
                                :src="info.student_thumb"
                                fit="contain"
                                :preview-src-list="[info.student_thumb]">
                            </el-image> -->
                            <img class="img" :src="info.student_thumb"  alt="">
                        </div>
                        <div class="info-r">
                            <p class="info-r-t item cell title">考籍档案基本信息</p>
                            <p class="item">
                                <span class="title cell w-14 b-r">准考证</span>
                                <span class="cell w-24 b-r">{{info.exam_number}}</span>
                                <span class="title cell w-14 b-r">姓名</span>
                                <span class="cell w-20 b-r">{{info.student_title}}</span>
                                <span class="title cell w-14 b-r">性别</span>
                                <span class="cell w-14">{{info.sex_title}}</span>
                            </p>
                            <p class="item">
                                <span class="title cell w-14 b-r">身份证</span>
                                <span class="cell w-24 b-r">{{info.identity}}</span>
                                <span class="title cell w-14 b-r">民族</span>
                                <span class="cell w-20 b-r">{{info.nation}}</span>
                                <span class="title cell w-14 b-r">籍贯</span>
                                <span class="cell w-14">{{info.office}}</span>
                            </p>
                            <p class="item">
                                <span class="title cell w-14 b-r">建档专业</span>
                                <span class="cell w-38 b-r">{{info.profession_title}}</span>
                                <span class="title cell w-20 b-r">层次</span>
                                <span class="cell w-28">{{info.level}}</span>
                            </p>
                            <p class="item">
                                <span class="title cell w-14 b-r">地址</span>
                                <span class="cell w-85">{{info.address}}</span>
                            </p>
                            <p class="item">
                                <span class="title cell w-14 b-r">电话</span>
                                <span class="cell w-85">{{info.mobile}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="notice">
                        <div class="notice-title">{{info.exam_title}}</div>
                        <div class="notice-t">
                            <span class="notice-t-text">准考证号：{{info.exam_number}}</span>
                            <span class="notice-t-text">姓名：{{info.student_title}}</span>
                            <span class="notice-t-text tips">请带上身份证和打印的考签</span>
                        </div>
                        <el-table
                            class="table"
                            :data="info.exam_arr"
                            border
                        >
                            <el-table-column prop="exam_time" label="考试时间" align="center"> </el-table-column>
                            <el-table-column prop="course_title" label="考试课程" align="center"> </el-table-column>
                            <el-table-column prop="exam_address" label="考试地点" align="center"> </el-table-column>
                            <el-table-column prop="room_sn" label="考场" align="center"> </el-table-column>
                            <el-table-column prop="seat_number" label="座位" align="center"> </el-table-column>
                        </el-table>
                        <div class="tips-b" v-html="info.exam_notice">
                            <!-- 1、重要纪律规定:根据教育部33号令，考试过程中发现随身携带手机等移动通讯工具的，无论开关机状态,均认定为作弊，取消当次参加考试的各科成绩，如接到的信息与本次考试有关，将追查信息来源榕昭相关规定严肃处理。请考生严格谨守 -->
                            <!-- {{info.exam_notice}} -->
                        </div>
                    </div>
                </div>
                <div class="btn no-print">
                    <!-- <el-button type="primary" @click="printClick">打印</el-button> -->
                    <!-- <el-button type="primary" v-print="printConfig">打印</el-button> -->
                    <el-button type="primary" @click="print" v-show="!isPrint">打印</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ownStudentNewExamInfo } from '@/api/exam';
import print from 'vue-print-nb';
export default {
    name: 'examSignIn',
    directives: { print },
    data(){
        return {
            id: this.$route.query.id,

            info: {},  //数据
            // 打印配置
            printConfig: {
                id: 'printCont',
                previewTitle: '考籍档案基本信息', // 预览页面的标题
            },
            isPrint: false,
        }
    },
    created(){
        this.getData();  //获取数据
    },
    methods: {
        print() {
            this.isPrint = true;
            setTimeout(() => {
                this.$print(this.$refs['print-content'])  //打印
                this.isPrint = false;
            });
        },
        // 点击打印
        printClick(){
            window.print();
        },
        // 获取数据
        getData(){
            let data = {
                id: this.id,
            };
            ownStudentNewExamInfo(data).then(res => {
                if(res.code == 200){
                    this.info = res.result;
                }
            });
        },
    },
}
</script>

<!-- <style>
    .uni-template .uni-scroll-container{
        background-color: #fff !important;
    }
</style> -->

<style lang="scss">
$font-size: 18px;  //字体大小
$border-color: #555;
.notice{

    .cell{
        font-size: $font-size;
    }

    // .el-table--border:after,
    // .el-table--group:after,
    // .el-table:before {
    //     background-color: #cecece;
    // }

    .el-table--border,
    .el-table--group {
        border-color: $border-color;
    }

    .el-table td,
    .el-table th.is-leaf {
        border-color:  $border-color;
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type {
        border-color:  $border-color;
    }

    .el-table--border td,
    .el-table--border th {
        border-color:  $border-color;
    }

    .el-table--border,
    .el-table--group {
        border: 1px solid $border-color;
    }

}
</style>

<style lang="scss" scoped>
$border-color: #555;  //边框颜色 灰色
$font-size: 18px;  //字体大小

.examSignIn{
    padding: 20px;
    background-color: #fff;
}
.examSignIn-box{
    padding: 20px;
    .printCont{
        width: 1000px;
        // margin: 0 auto;
    }
    .btn{
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
}
.logo{
    .img{
        height: 100px;
        object-fit: contain;
    }
}
.student-info{
    width: 100%;
    height: 240px;
    border: 1px solid $border-color;
    display: flex;
    margin-top: 20px;
    .info-l{
        width: 15%;
        height: 100%;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid $border-color;
        .img{
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    .info-r{
        width: calc(100% - 15%);
        .item{
            width: 100%;
            height: 40px;
            border-bottom: 1px solid $border-color;
            display: flex;
            &:last-child{
                border-bottom: none;
            }
        }
        .cell{
            display: inline-block;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: $font-size;
        }
        .title{
            font-weight: bold;
        }
        .b-r{
            border-right: 1px solid $border-color;
        }
        .w-14{
            width: 14%;
        }
        .w-15{
            width: 15%;
        }
        .w-20{
            width: 20%;
        }
        .w-24{
            width: 24%;
        }
        .w-28{
            width: 28%;
        }
        .w-35{
            width: 35%;
        }
        .w-38{
            width: 38%;
        }
        .w-30{
            width: 30%;
        }
        .w-85{
            width: 85%;
        }
    }
}
.notice{
    width: 800px;
    margin: 0 auto;
    margin-top: 50px;
    border: 1px dashed $border-color;
    padding: 20px;
    .notice-title{
        font-size: 20px;
        font-weight: bold;
        text-align: center;
    }
    .notice-t{
        margin-top: 10px;
        display: flex;
        justify-content: space-around;
        font-size: $font-size;
        .notice-t-text.tips{
            font-weight: bold;
        }
    }
    .table{
        margin-top: 20px;
        font-size: $font-size;
    }
    .tips-b{
        margin-top: 20px;
        color: rgb(255, 0, 0);
        font-size: $font-size;
        white-space: pre-wrap;
    }
}
</style>
<style media="print">
@page {
  size: auto;
  margin: 3mm;
}
html {
  height: auto;
}
@media print {
  .no-print.itemimg {
    display: none;
  }
}
</style>
